import cn from './cn'
import en from './en'

const translations = {
  en,
  cn,
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/index.js